import React, { useState } from "react"

import useProgress from "../../hooks/useProgress"

import { Wrapper } from "./styles"

const ProgressBar = ({ hide }) => {
  const [currentProgress, setCurrentProgress] = useState(0)
  useProgress(setCurrentProgress)

  return <Wrapper style={{ width: `${currentProgress}%` }} hide={hide} />
}

export default React.memo(ProgressBar)
